<template>
  <s-modal id="home-modal" :title="'select_property' | translate | capitalize">
    <section slot="body">
      <div class="modal-body">
        <div class="form-group m-form__group">
          <div class="input-group" :class="{'has-danger': errors.has('search-field')}">
            <input type="text" class="form-control" :placeholder="'search_for' | capitalize" v-model="search" v-validate="{regex:/^[a-zA-Z0-9\- \s]*$/}" name="search-field">
          </div>
          <span v-show="errors.has('search-field')" class="m-form__help m--font-danger">{{ errors.first('search-field') }}</span>
        </div>
        <div v-show="has_data" class="m-portlet m-portlet--bordered-semi m-portlet--full-height m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="300">
          <div class="m-portlet__body">
            <div class="m-widget4">
              <div v-for="(p, index) in filterProperties()" :key="index" class="m-widget4__item">
                <div class="m-widget4__img m-widget4__img--logo">
                  <img :src="p.image ? `/media/img/properties/${p.image}` : '/media/img/logo_m.png'" alt="">
                </div>
                <div class="m-widget4__info">
                  <span class="m-widget4__title">
                    {{ p.name }} - {{ p.profile_name }}
                  </span>
                  <br>
                  <span class="m-widget4__sub">
                    {{ p.company }}
                  </span>
                  <br>
                </div>
                <span class="m-widget4__ext">
                  <a href="" class="btn btn-success" data-dismiss="modal"  @click.prevent="enter(p.index)">{{ 'continue' | translate | capitalize }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!has_data">
          <div id="container-no-data">
            <i class="flaticon-circle"></i>
            <p>{{ 'no_data' | translate | capitalize }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a href="" class="btn btn-primary m-btn  m-btn--custom " data-dismiss="modal" @click.prevent="logout()">
          {{ 'logout' | translate | capitalize }}
        </a>
      </div>
    </section>
  </s-modal>
</template>

<script>
  import SModal from '@/components/layout/modal/Modal.vue'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    components: { SModal },
    data () {
      return {
        properties: [],
        search: '',
        has_data: false
      }
    },
    created () {
      let i18n = this.$i18n
      this.$spinner.show()
      this.$store.dispatch('getUserData', this.user_email)
        .then((res) => {
          this.$store.dispatch('postGetProperties', this.user_data.profiles)
            .then((res) => {
              this.$spinner.remove()
              this.properties = res.data
              this.has_data = true
              this.filterProperties()
              this.initLanguage(i18n)
            })
            .catch((err) => {
              this.$spinner.remove()
              console.log(err)
            })
        })
      this.$spinner.remove()
      setTimeout(() => {
        window.$('#home-modal').modal({
          backdrop: 'static',
          keyboard: false
        })
      }, 1)
      setTimeout(() => {
        window.mApp.initComponents()
      }, 200)
    },
    methods: {
      ...mapActions(['changeLanguageStatus', 'sections', 'postDataUserProfile']),
      filterProperties () {
        if (this.properties.length === 0) {
          this.$spinner.show()
        } else if (this.properties.length > 0) {
          this.$spinner.remove()
        }
        let array1 = this.properties.filter(prop => {
          return prop.name.toLowerCase().includes(this.search.toLowerCase())
        })
        let array2 = this.properties.filter(prop => {
          return prop.company.toLowerCase().includes(this.search.toLowerCase())
        })
        let array3 = this.properties.filter(prop => {
          return prop.profile_name.toLowerCase().includes(this.search.toLowerCase())
        })
        const all_data = Object.assign({}, array1, array2, array3)
        Object.keys(all_data).length <= 0 ? this.has_data = false : this.has_data = true
        return all_data
      },
      enter (index) {
        this.$store.commit('setUserShard', { shard: this.properties[index].shard, profile_id: this.properties[index].profile_id, company_id: this.properties[index].company_id, allow_credentials_assigned: this.properties[index].allow_credentials_assigned })
        this.sections().then((res) => { this.$spinner.remove() })
        this.$toast('welcome_property', 1, 5000, 100, false, 'property', this.properties[index].prop_config)
        window.$('#home-modal').modal('toggle')
        this.postDataUserProfile({ shard: this.properties[index].shard, profile_id: this.properties[index].profile_id, company_id: this.properties[index].company_id })
          .then((res) => {
            document.getElementById('nameCompanyProfile').innerHTML = ''
            document.getElementById('nameProfileProfile').innerHTML = ''
            document.getElementById('nameCompanyProfile').innerHTML = res.data.company
            document.getElementById('nameProfileProfile').innerHTML = res.data.profile
          })
          .catch((err) => {
            console.log(err)
          })
        this.$router.push({ name: 'home' })
      },
      logout () {
        this.$store.dispatch('postLogout')
        this.$store.state.authentication.logged_in = false
        localStorage.removeItem('logged_in')
        localStorage.removeItem('user_email')
        localStorage.removeItem('user_data')
        localStorage.removeItem('user_shard')
        localStorage.removeItem('sections')
        this.$store.commit('addSections', [])
        window.$('#home-modal').modal('toggle')
        this.$router.replace({ name: 'login' })
      },
      initLanguage (i18n) {
        if (this.change_language) {
          this.$store.dispatch('getEditLanguage', this.get_language)
            .then((res) => {
              this.changeLanguageStatus(false)
            })
        } else {
          let user_language = this.user_data.language
          if (user_language !== null) {
            if (user_language !== i18n.locale) {
              this.$store.commit('setLocalLanguage', user_language)
              i18n.locale = user_language
              this.$validator.localize(user_language)
            }
          } else {
            this.$store.dispatch('getEditLanguage', i18n.locale)
              .then((res) => {
              })
          }
        }
      }
    },
    computed: {
      ...mapGetters({user_email: 'getUserEmail', get_language: 'getLocalLanguage', user_data: 'getUserData', change_language: 'getLanguageChange'})
    }
  }
</script>

<style scoped>
  .m-portlet__body {
    padding-bottom: 8px !important;
  }
  .m-widget4__item {
    border-bottom: 0.15rem solid #ebedf2 !important;
  }

  #container-no-data {
    text-align: center;
  }

  #container-no-data > i {
    font-size: 150px !important;
  }

  #container-no-data > p {
    font-size: 50px !important;
  }

  .m-widget4__sub {
    font-size: 0.99rem !important;
  }
</style>


// WEBPACK FOOTER //
// List.vue